document.addEventListener("DOMContentLoaded", () => {
  // お役立ち資料ダウンロード詳細ページ　関連記事スライダー
  if (document.querySelector('.caseOthersBlock')) {
    window.addEventListener('load', () => {
      const swiperEl = document.querySelector('.caseOthersSwiper');
      if (!swiperEl) return;
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;
      const slideCount = slides.length;
      const caseOthersSwiper = new Swiper(swiperEl, {
        loop: slideCount > 1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 400,
        allowTouchMove: true,
        autoplay: false,
        breakpoints: {
          735: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  }
});
